import { useState, useContext, useEffect } from 'react';

import classes from './QOption.module.scss';
import TriviaContext from '../../store/trivia-context';

function QOption(props) {
    const triviaCtx = useContext(TriviaContext);
    const [optionStatusClasses, setOptionStatusClasses] = useState();

    let qletter;
    switch (props.optionNo) {
        case 0:
            qletter = 'A';
            break;
        case 1:
            qletter = 'B';
            break;
        case 2:
            qletter = 'C';
            break;
        case 3:
            qletter = 'D';
            break;

        default:
            break;
    };

    useEffect(() => {
        if (triviaCtx.isOptionSelectedByUser && props.answerIndex === props.optionNo) {
            setOptionStatusClasses(classes["q-right"]);
        }
        if (!triviaCtx.isOptionSelectedByUser) {
            setOptionStatusClasses(null);
        }
    }, [triviaCtx.isOptionSelectedByUser, props.answerIndex, props.optionNo]);

    function optionSlectedHandler() {
        triviaCtx.setIsOptionSelectedByUser(true);
        if (props.answerIndex !== props.optionNo) {
            setOptionStatusClasses(classes["q-wrong"]);
        }
        triviaCtx.setTriviaStatus(triviaCtx.currentQuestionNo, props.answerIndex === props.optionNo);

    }

    return (
        <button className={`${classes["q-option"]} ${optionStatusClasses}`} onClick={optionSlectedHandler} disabled={triviaCtx.isOptionSelectedByUser}>
            <span className={classes["q-option--no"]}>{qletter}.</span>
            <span className={classes["q-option--text"]}>{props.children}</span>
        </button>
    )
}

export default QOption
